export default "__VITE_ASSET__BvY_p746__"